import Dictionary from "./Dictionary.js";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"></header>
        <main>
          <Dictionary defaultWord="wine" />
        </main>
        <footer className="App-footer">
          <small>This project was coded by Ioanna Karagkani</small>
        </footer>
      </div>
    </div>
  );
}
